/**
 * Employee Web — `/me` pathless parent.
 *
 * Phase 05.2-05 (Plan 05) — passthrough only. The 6-tab profile shell
 * moved to `/me/profile/*` (see `_auth.me.profile.tsx`). `/me` itself is
 * now a pathless container for sibling self-service routes:
 *   - `/me/` (index)        → MeDashboard
 *   - `/me/profile/*`       → 6-tab profile (Personal / Work / Documents /
 *                              Emergency / Bank & Tax / Security)
 *   - `/me/my-leave`        → leave balance
 *   - `/me/my-attendance`   → attendance log
 *   - `/me/punch`           → clock in/out (Phase 5)
 *   - `/me/calendar`        → unified calendar (Phase 05.2 Plan 10)
 *   - `/me/requests/*`      → requests inbox + new
 *   - `/me/reviews/*`       → appraisal reviewer (Phase 05.1)
 *   - `/me/preferences`     → notification preferences
 *   - `/me/payroll`         → payroll-self (Phase 05.2 Plan 13)
 *   - `/me/loans`           → loans
 *   - `/me/directory`       → coworker directory
 *
 * Each child renders its own page chrome. The historic shared tab strip
 * lived in `MeProfileLayout` which is now scoped to `/me/profile/*`.
 */
import type { JSX } from "react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteErrorFallback } from "../components/RouteErrorFallback";

export const Route = createFileRoute("/_auth/me")({
  component: MePathlessParent,
  // Backstop for the whole /me/* self-service tree: a render throw in any child
  // degrades to an in-shell retry card instead of the blank root error boundary.
  errorComponent: RouteErrorFallback,
});

function MePathlessParent(): JSX.Element {
  return <Outlet />;
}
